import assign from 'object-assign';

import { OBJECTIVE_LIST_REQUEST, OBJECTIVE_LIST_SUCCESS, OBJECTIVE_LIST_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_ADD_REQUEST, OBJECTIVE_ADD_SUCCESS, OBJECTIVE_ADD_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_UPDATE_REQUEST, OBJECTIVE_UPDATE_SUCCESS, OBJECTIVE_UPDATE_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_DELETE_REQUEST, OBJECTIVE_DELETE_SUCCESS, OBJECTIVE_DELETE_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_SUMMARY_REQUEST, OBJECTIVE_SUMMARY_SUCCESS, OBJECTIVE_SUMMARY_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_BY_TIME_REQUEST, OBJECTIVE_BY_TIME_SUCCESS, OBJECTIVE_BY_TIME_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_COPY_REQUEST, OBJECTIVE_COPY_SUCCESS, OBJECTIVE_COPY_FAILURE } from '../../action/okr_manage/objective';
import { OBJECTIVE_BY_TIMES_REQUEST, OBJECTIVE_BY_TIMES_SUCCESS, OBJECTIVE_BY_TIMES_FAILURE } from '../../action/okr_manage/objective';


const initState = {
  showLoading: false,
  objectList: {
    objectives: [],
    page: 1,
    total: 0,
    pageSize: 10
  },
  timeObjectives: [],
  objectiveSummary: {
    objective: {},
    parentObjective: {},
    krs: [],
    childObjectives: [],
    initiatives: []
  },
  objectTimeframesList: []
};


function okrObjectives(state = initState, action) {
  switch (action.type) {
    //OBJECT
    case OBJECTIVE_LIST_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_LIST_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        objectList: assign({}, state.objectList, action.response.result)
      });
    case OBJECTIVE_LIST_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_ADD_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_ADD_SUCCESS:
      return assign({}, state, { showLoading: false });
    case OBJECTIVE_ADD_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_UPDATE_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_UPDATE_SUCCESS:
      return assign({}, state, { showLoading: false })
    case OBJECTIVE_UPDATE_FAILURE:
      return assign({}, state, { showLoading: false })

    case OBJECTIVE_DELETE_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_DELETE_SUCCESS:
      return assign({}, state, { showLoading: false });
    case OBJECTIVE_DELETE_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_SUMMARY_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_SUMMARY_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        objectiveSummary: action.response.result
      });
    case OBJECTIVE_SUMMARY_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_BY_TIME_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_BY_TIME_SUCCESS:
      return assign({}, state, {
        showLoading: false,
        timeObjectives: action.response.result.objectives
      });
    case OBJECTIVE_BY_TIME_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_COPY_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_COPY_SUCCESS:
      return assign({}, state, { showLoading: false, });
    case OBJECTIVE_COPY_FAILURE:
      return assign({}, state, { showLoading: false });

    case OBJECTIVE_BY_TIMES_REQUEST:
      return assign({}, state, { showLoading: true });
    case OBJECTIVE_BY_TIMES_SUCCESS:
      return assign({}, state, { showLoading: false, objectTimeframesList: action.response.result.list || [] });
    case OBJECTIVE_BY_TIMES_FAILURE:
      return assign({}, state, { showLoading: false, });

    default:
      return state
  }
}

export default okrObjectives;


// WEBPACK FOOTER //
// ./src/reducer/okr_manage/okr_objective.js